<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Asana" class="d-icon d-icon--asana" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.65 12.787a4.35 4.35 0 1 0 0 8.699 4.35 4.35 0 0 0 0-8.7Zm-11.3 0a4.35 4.35 0 1 0 0 8.7 4.35 4.35 0 0 0 0-8.7Zm10-5.437a4.35 4.35 0 1 1-8.7 0 4.35 4.35 0 0 1 8.7 0Z" :fill="`url(#${uniqueID}a)`"/><defs><radialGradient :id="`${uniqueID}a`" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(13.2526 0 0 12.2495 12 13.103)"><stop stop-color="#FFB900"/><stop offset=".6" stop-color="#F95D8F"/><stop offset=".999" stop-color="#F95353"/></radialGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconAsana',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
